/**
 * Integrytas Group - Common Security Module (CSM)
 * Nav-group detection.
 *
 * A menu node whose internal_code is a macro-group (a container, NEVER an
 * openable page — it has no registered component) is identified by the platform
 * naming convention, NOT a hardcoded prefix:
 *
 *   • Core BaseApp groups start with `NAV.`      — e.g. NAV.SECURITY, NAV.BASE_TABLES
 *   • Derived-app business-domain groups (§17.E) — `<PREFIX>.NAV.<DOMAIN>`,
 *     e.g. EMC.NAV.WALKS, ATC.NAV.PROCUREMENT, EMC.NAV.BASE_TABLES.WALKS
 *
 * So a group has a `NAV.` *segment*: `NAV.` at the very start, or `.NAV.` after
 * a module prefix. Search, the command palette and the breadcrumb must never
 * surface a group node as a navigable target (doing so opens a tab with "No
 * component registered"). Matching only `startsWith('NAV.')` missed every
 * derived-app domain group — this helper is the single source of truth.
 */
export function is_nav_group_code(internal_code: string): boolean {
  return /(^|\.)NAV\./.test(internal_code);
}
